/**
 * Date formatting utilities for business-date ISO strings (YYYY-MM-DD).
 *
 * Epic 3 (tijdvakken) toont datums als "1 feb 2026". Business-datums zijn
 * platte ISO-strings zonder tijdcomponent (AD-1/backend-conventie) — we
 * parsen de componenten handmatig i.p.v. `new Date(iso)` + `toLocaleDateString`
 * te gebruiken, zodat er nooit een timezone-afhankelijke dag-verschuiving
 * kan optreden.
 */

const DUTCH_MONTHS_SHORT = [
  'jan', 'feb', 'mrt', 'apr', 'mei', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec',
];

/** "2026-02-01" -> "1 feb 2026" */
export function formatDutchDate(isoDate: string): string {
  const parts = isoDate.split('-').map(Number);
  const year = parts[0];
  const month = parts[1];
  const day = parts[2];
  if (!year || !month || !day) return isoDate;
  return `${day} ${DUTCH_MONTHS_SHORT[month - 1]} ${year}`;
}

/** Tijdvak-periode-string: "1 feb 2026 – heden" of "1 jan 2025 – 31 jan 2026". */
export function formatPeriodRange(startDate: string, endDate: string | null): string {
  const start = formatDutchDate(startDate);
  const end = endDate === null ? 'heden' : formatDutchDate(endDate);
  return `${start} – ${end}`;
}
